// Action Types as string literals
export const SET_DRAGGING = '@@dragState/SET_DRAGGING';
export const SET_DRAGGED_ITEM = '@@dragState/SET_DRAGGED_ITEM';

// Define Types

// Action Creators
export function setDragging(isDragging) {
  return {
    type: SET_DRAGGING,
    isDragging
  };
}
export function setDraggedItem(item) {
  return {
    type: SET_DRAGGED_ITEM,
    item
  };
}

// Action Thunks
export function startDrag(item) {
  return dispatch => {
    dispatch(setDragging(true));
    if (item) {
      dispatch(setDraggedItem(item));
    }
  };
}
export function endDrag() {
  return dispatch => {
    dispatch(setDragging(false));
    dispatch(setDraggedItem(null));
  };
}